export default {
    hostLogin: 'http://10.1.138.14:5086',
    timeout: 10000,
    MOCK: false
}